<template>
 <div class="card">
    <div class="card-content">
      <div class="columns is-multiline">
        <b-field :label="$t('factorFacture.factor')" class="column is-4"
                  custom-class="has-text-weight-bold mgb-0">
          <span class="has-text-default">
            {{ detailDevisCommande.tiersFactorId ?
              detailDevisCommande.tiersFactor.nomCommercial : '' }}
          </span>
        </b-field>
        <b-field :label="$t('factorFacture.transmis')" class="column is-narrow"
                  custom-class="has-text-weight-bold mgb-0">
          <span class="has-text-default">
            {{ detailDevisCommande.factorTransmis ? $t('general.oui') : $t('general.non')}}
          </span>
        </b-field>
        <b-field :label="$t('factorFacture.dateTransmission')" class="column is-narrow"
                  custom-class="has-text-weight-bold mgb-0">
          <span class="has-text-default">
            {{ detailDevisCommande.factorDateTransmission }}
          </span>
        </b-field>
        <b-field :label="$t('factorFacture.commentaire')" class="column is-12"
                 custom-class="has-text-weight-bold mgb-0">
          <span v-html="detailDevisCommande.commentaireFactor"></span>
        </b-field>
      </div>
    </div>
 </div>
</template>

<script>
export default {
  name: 'FactureDetailFactor',
  props: {
    detailDevisCommande: {
      type: Object,
      required: true,
    },
  },
};
</script>
